import { LoginComponent } from './client/login/login.component';
import { Routes } from '@angular/router';
import { DestinationsComponent } from './client/destinations/destinations.component';
import { ArticlesComponent } from './client/articles/articles.component';
import { ArticleComponent } from './client/articles/article/article.component';
import { FileComponent } from './client/file/file.component';
import { TagsComponent } from './client/tags/tags.component';
import { AuthGuard, ArticleType } from './shared/public-api';
import { Publish } from './client/publish/publish';

export const adminRoutes: Routes = [
  {
    path: 'destinations',
    component: DestinationsComponent,
    canActivate: [AuthGuard],
  },
  { path: 'articles', component: ArticlesComponent, canActivate: [AuthGuard] },
  {
    path: 'accomodations',
    component: ArticlesComponent,
    canActivate: [AuthGuard],
    data: { articleType: ArticleType.Accommodation },
  },
  { path: 'article', component: ArticleComponent, canActivate: [AuthGuard] },
  {
    path: 'article/:articleId',
    component: ArticleComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'setups',
    component: ArticlesComponent,
    canActivate: [AuthGuard],
    data: { articleType: ArticleType.Setup },
  },
  { path: 'files', component: FileComponent, canActivate: [AuthGuard] },
  { path: 'tags', component: TagsComponent, canActivate: [AuthGuard] },
  { path: 'publish', component: Publish, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
];
